import { SxProps, Theme } from "@mui/material/styles";

const baseCell: SxProps<Theme> = {
  fontSize: "10px",
  lineHeight: 2,
  fontFamily: "Inter",
  paddingLeft: "3px",
};

const ReceiptDetailsStyles: Record<string, SxProps<Theme>> = {
  cell: {
    ...baseCell,
    border: "0px",
  },
  cellWithRightBorder: {
    ...baseCell,
    borderRight: "3px solid black",
    borderBottom: "2px solid black",
    width: "50%",
  },
  cellWithRightBorderOnly: {
    ...baseCell,
    borderRight: "3px solid black",
    borderBottom: "2px solid black",
  },
  cellBottomBorder: {
    ...baseCell,
    borderBottom: "2px solid black",
  },
  cellBorderAllLeftRight: {
    ...baseCell,
    border: "3px solid black",
    borderLeft: "0",
    fontWeight: 500,
  },
  cellBorderAllRight: {
    ...baseCell,
    border: "3px solid black",
    borderRight: "0",
    fontWeight: 500,
  },
  rowSpanCell: {
    ...baseCell,
    borderRight: "3px solid black",
  },
  labelSpan: {
    fontSize: "10px",
    fontWeight: 500,
  },
  labelSpanBold: {
    fontSize: "10px",
    fontWeight: 600,
  },
};

export default ReceiptDetailsStyles;
